// reducers/employee-onboarding/skip.js

export function skipHasErrored(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_SKIP_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function skipIsLoading(state = false, action) {
  switch (action.type) {
    case 'ONBOARDING_SKIP_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function skip(state = {}, action) {
  switch (action.type) {
    case 'ONBOARDING_SKIP_FETCH_DATA_SUCCESS':
      return action.data;
    default:
      return state;
  }
}